import React from "react";
import { Typography, Box, useMediaQuery, useTheme, Button } from "@mui/material";
import { IMG_HOME_PAGE_IMAGE } from "./imageConfig";
import EmailPopup from "./EmailPopup";
import { useNavigate } from "react-router-dom";

function Home() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const navigate = useNavigate();

  return (
    <Box sx={{ mt: isMobile ? "94px" : "154px", position: "relative", width: "100%", lineHeight: 0 }}>
      <Box
        component="img"
        src={IMG_HOME_PAGE_IMAGE}
        alt="DAINA Indian ethnic wear: timeless style, thoughtfully chosen"
        sx={{ width: "100%", height: "auto", display: { xs: "none", md: "block" } }}
      />
      {!isMobile && (
        <Button
          aria-label="Shop DAINA Indian ethnic wear"
          onClick={() => navigate("/all-products", { state: { customHeading: "Women's Ethnic Wear" } })}
          sx={{
            position: "absolute",
            left: "10.8%",
            bottom: "13.8%",
            width: "15.8%",
            height: "7.8%",
            minWidth: 0,
            p: 0,
            opacity: 0,
            borderRadius: 0,
            "&:focus-visible": {
              opacity: 1,
              outline: "2px solid #fff",
              backgroundColor: "rgba(138,45,49,0.2)",
            },
          }}
        />
      )}
      {isMobile && (
        <Box
          role="img"
          aria-label="DAINA Indian ethnic wear collection"
          sx={{
            minHeight: "calc(100vh - 94px)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "center",
            textAlign: "center",
            px: 3,
            pb: 5,
            boxSizing: "border-box",
            backgroundImage: `url(${IMG_HOME_PAGE_IMAGE})`,
            backgroundSize: "auto 100%",
            backgroundPosition: "70% center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Box sx={{ width: "100%", py: 3, background: "linear-gradient(transparent, rgba(22, 17, 13, 0.72))" }}>
            <Typography sx={{ color: "#fff", fontFamily: '"Playfair Display", serif', fontSize: "1.75rem", mb: 1 }}>
              Indian Ethnic Wear
            </Typography>
            <Typography sx={{ color: "#fff", fontSize: "0.95rem", mb: 2 }}>
              Timeless style, thoughtfully chosen.
            </Typography>
            <Button
              variant="contained"
              onClick={() => navigate("/all-products", { state: { customHeading: "Women's Ethnic Wear" } })}
              sx={{ bgcolor: "#8a2d31", color: "#fff", borderRadius: 0, px: 3, py: 1.25, "&:hover": { bgcolor: "#702327" } }}
            >
              SHOP NOW
            </Button>
          </Box>
        </Box>
      )}
      <EmailPopup />
    </Box>
  );
}

export default Home;
